// extracted by mini-css-extract-plugin
export var attributionShimmer = "styles-module__attributionShimmer___yalsL";
export var conditionsRow = "styles-module__conditionsRow___s56_D";
export var shimmerCondition = "styles-module__shimmerCondition___IYO4v";
export var shimmerContainer = "styles-module__shimmerContainer___o4jmL";